module.exports = __webpack_public_path__ + "41929500e241af7a7838aba32baa39c0.svg";